import KeycloakService from "@/core/services/KeycloakService";
import MensagemService from "@/core/services/MensagemService";
import store from "@/store";
import { useUsuarioStore } from "@/store/usuarioStore";
import { Mutations } from "@/store/enums/StoreEnums";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { manutencao_historico } from "./manutencao-historico";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        meta: {
          requireAuth: false,
        },
        component: () => import("@/views/Dashboard.vue"),
      },
    ],
  },
  {
    path: "/pais",
    redirect: "/pais",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/pais/novo",
        name: "pais_novo",
        meta: {
          allowedPermissions: ["pais_create"],
        },
        component: () => import("@/views/Pais/PaisCad.vue"),
      },
      {
        path: "/pais/edit/:id",
        name: "pais_atualizar",
        meta: {
          allowedPermissions: ["pais_edit"],
        },
        component: () => import("@/views/Pais/PaisEdit.vue"),
      },
      {
        path: "/pais",
        name: "pais",
        meta: {
          allowedPermissions: ["pais_list"],
        },
        component: () => import("@/views/Pais/PaisHome.vue"),
      },
    ],
  },
  {
    path: "/zona",
    redirect: "/zona",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/zona/novo",
        name: "zona_novo",
        meta: {
          allowedPermissions: ["zona_create"],
        },
        component: () => import("@/views/Zona/ZonaCad.vue"),
      },
      {
        path: "/zona/edit/:id",
        name: "zona_atualizar",
        meta: {
          allowedPermissions: ["zona_edit"],
        },
        component: () => import("@/views/Zona/ZonaEdit.vue"),
      },
      {
        path: "/zona",
        name: "zona",
        meta: {
          allowedPermissions: ["zona_index"],
        },
        component: () => import("@/views/Zona/ZonaHome.vue"),
      },
    ],
  },
  {
    path: "/polo",
    redirect: "/polo",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/polo/novo",
        name: "polocad",
        meta: {
          allowedPermissions: ["polo_create"],
        },
        component: () => import("@/views/Polo/PoloCad.vue"),
      },
      {
        path: "/polo/edit/:id",
        name: "poloedit",
        meta: {
          allowedPermissions: ["polo_edit"],
        },
        component: () => import("@/views/Polo/PoloEdit.vue"),
      },
      {
        path: "/polo",
        name: "polo",
        meta: {
          allowedPermissions: ["polo_index"],
        },
        component: () => import("@/views/Polo/PoloHome.vue"),
      },
    ],
  },
  {
    path: "/calha",
    redirect: "/calha",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/calha/novo",
        name: "calhacad",
        meta: {
          allowedPermissions: ["calha_create"],
        },
        component: () => import("@/views/Calha/CalhaCad.vue"),
      },
      {
        path: "/calha/edit/:id",
        name: "calhaedit",
        meta: {
          allowedPermissions: ["calha_edit"],
        },
        component: () => import("@/views/Calha/CalhaEdit.vue"),
      },
      {
        path: "/calha",
        name: "calha",
        meta: {
          allowedPermissions: ["calha_list"],
        },
        component: () => import("@/views/Calha/CalhaHome.vue"),
      },
    ],
  },
  {
    path: "/mesorregiao",
    redirect: "/mesorregiao",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/mesorregiao/novo",
        name: "mesorregiaocad",
        meta: {
          allowedPermissions: ["mesorregiao_create"],
        },
        component: () => import("@/views/Mesorregiao/MesoCad.vue"),
      },
      {
        path: "/mesorregiao/edit/:id",
        name: "mesorregiaoedit",
        meta: {
          allowedPermissions: ["mesorregiao_edit"],
        },
        component: () => import("@/views/Mesorregiao/MesoEdit.vue"),
      },
      {
        path: "/mesorregiao",
        name: "mesorregiao",
        meta: {
          allowedPermissions: ["mesorregiao_list"],
        },
        component: () => import("@/views/Mesorregiao/MesoHome.vue"),
      },
    ],
  },
  {
    path: "/microrregiao",
    redirect: "/microrregiao",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/microrregiao/novo",
        name: "microrregiaocad",
        meta: {
          allowedPermissions: ["microrregiao_create"],
        },
        component: () => import("@/views/Microrregiao/MicroCad.vue"),
      },
      {
        path: "/microrregiao/edit/:id",
        name: "microrregiaoedit",
        meta: {
          allowedPermissions: ["microrregiao_edit"],
        },
        component: () => import("@/views/Microrregiao/MicroEdit.vue"),
      },
      {
        path: "/microrregiao",
        name: "microrregiao",
        meta: {
          allowedPermissions: ["microrregiao_list"],
        },
        component: () => import("@/views/Microrregiao/MicroHome.vue"),
      },
    ],
  },
  {
    path: "/municipio",
    redirect: "/municipio",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/municipio/novo",
        name: "municipiocad",
        meta: {
          allowedPermissions: ["municipio_create"],
        },
        component: () => import("@/views/Municipio/MuniCad.vue"),
      },
      {
        path: "/municipio/edit/:id",
        name: "municipioedit",
        meta: {
          allowedPermissions: ["municipio_edit"],
        },
        component: () => import("@/views/Municipio/MuniEdit.vue"),
      },
      {
        path: "/municipio",
        name: "municipio",
        meta: {
          allowedPermissions: ["municipio_index"],
        },
        component: () => import("@/views/Municipio/MuniHome.vue"),
      },
    ],
  },
  {
    path: "/bairro_oficial",
    redirect: "/bairro_oficial",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/bairro_oficial/novo",
        name: "bairro_oficialcad",
        meta: {
          allowedPermissions: ["bairro_oficial_create"],
        },
        component: () => import("@/views/BairroOf/BairroOfCad.vue"),
      },
      {
        path: "/bairro_oficial/edit/:id",
        name: "bairro_oficialedit",
        meta: {
          allowedPermissions: ["bairro_oficial_edit"],
        },
        component: () => import("@/views/BairroOf/BairroOfEdit.vue"),
      },
      {
        path: "/bairro_oficial",
        name: "bairro_oficial",
        meta: {
          allowedPermissions: ["bairro_oficial_list"],
        },
        component: () => import("@/views/BairroOf/BairroOfHome.vue"),
      },
    ],
  },
  {
    path: "/bairro",
    redirect: "/bairro",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/bairro/novo",
        name: "bairrocad",
        meta: {
          allowedPermissions: ["bairro_create"],
        },
        component: () => import("@/views/Bairro/BairroCad.vue"),
      },
      {
        path: "/bairro/edit/:id",
        name: "bairroedit",
        meta: {
          allowedPermissions: ["bairro_edit"],
        },
        component: () => import("@/views/Bairro/BairroEdit.vue"),
      },
      {
        path: "/bairro",
        name: "bairro",
        meta: {
          allowedPermissions: ["bairro_list"],
        },
        component: () => import("@/views/Bairro/BairroHome.vue"),
      },
    ],
  },
  {
    path: "/local_sala_fora",
    redirect: "/local_sala_fora",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/local_sala_fora/novo",
        name: "local_sala_foracad",
        meta: {
          allowedPermissions: ["localsalafora_create"],
        },
        component: () => import("@/views/Localidade/LocalCad.vue"),
      },
      {
        path: "/local_sala_fora/edit/:id",
        name: "local_sala_foraedit",
        meta: {
          allowedPermissions: ["localsalafora_edit"],
        },
        component: () => import("@/views/Localidade/LocalEdit.vue"),
      },
      {
        path: "/local_sala_fora",
        name: "local_sala_fora",
        meta: {
          allowedPermissions: ["localsalafora_index"],
        },
        component: () => import("@/views/Localidade/LocalHome.vue"),
      },
    ],
  },
  {
    path: "/coordenadoria",
    redirect: "/coordenadoria",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/coordenadoria/novo",
        name: "coordenadoriacad",
        meta: {
          allowedPermissions: ["coordenadoria_create"],
        },
        component: () => import("@/views/Coordenadoria/CoordCad.vue"),
      },
      {
        path: "/coordenadoria/edit/:id",
        name: "coordenadoriaedit",
        meta: {
          allowedPermissions: ["coordenadoria_edit"],
        },
        component: () => import("@/views/Coordenadoria/CoordEdit.vue"),
      },
      {
        path: "/coordenadoria",
        name: "coordenadoria",
        meta: {
          allowedPermissions: ["coordenadoria_index"],
        },
        component: () => import("@/views/Coordenadoria/CoordHome.vue"),
      },
    ],
  },
  {
    path: "/atividadescomplementares",
    redirect: "/atividadescomplementares",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/atividadescomplementares",
        name: "atividadescomplementares",
        meta: {
          allowedPermissions: ["atividadecomplementar_index"],
        },
        component: () => import("@/views/Atividades/AtCompHome.vue"),
      },
      {
        path: "/atividadescomplementares/cadastro",
        name: "cadastroatividadescomplementares",
        meta: {
          allowedPermissions: ["atividadecomplementar_create"],
        },
        component: () => import("@/views/Atividades/AtCompCad.vue"),
      },
      {
        path: "/atividadescomplementares/editar/:id",
        name: "editaratividadescomplementares",
        meta: {
          allowedPermissions: ["atividadecomplementar_edit"],
        },
        component: () => import("@/views/Atividades/AtCompEd.vue"),
      },
    ],
  },
  {
    path: "/cartorios",
    redirect: "/cartorios",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/cartorios",
        name: "cartorios",
        meta: {
          allowedPermissions: ["cartorio_index"],
        },
        component: () => import("@/views/Cartorio/CartorioHome.vue"),
      },
      {
        path: "/cartorios/cadastrarcartorios",
        name: "cadastrarcartorios",
        meta: {
          allowedPermissions: ["cartorio_create"],
        },
        component: () => import("@/views/Cartorio/CartorioCad.vue"),
      },
      {
        path: "/cartorios/editarcartorios/:id",
        name: "editarcartorios",
        meta: {
          allowedPermissions: ["cartorio_edit"],
        },
        component: () => import("@/views/Cartorio/CartorioEd.vue"),
      },
    ],
  },
  {
    path: "/tipo_publicacao",
    redirect: "/tipo_publicacao",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/tipo_publicacao",
        name: "tipo_publicacao",
        meta: {
          allowedPermissions: ["tipopublicacao_index"],
        },
        component: () =>
          import("@/views/TipoPublicacao/TipoPublicacaoHome.vue"),
      },
      {
        path: "/tipo_publicacao/novo",
        name: "tipopublicacao_novo",
        meta: {
          allowedPermissions: ["tipopublicacao_create"],
        },
        component: () => import("@/views/TipoPublicacao/TipoPublicacaoCad.vue"),
      },
      {
        path: "/tipo_publicacao/edit/:id",
        name: "tipopublicacao_atualizar",
        meta: {
          allowedPermissions: ["tipopublicacao_edit"],
        },
        component: () =>
          import("@/views/TipoPublicacao/TipoPublicacaoEdit.vue"),
      },
    ],
  },
  {
    path: "/publicacao",
    redirect: "/publicacao",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/publicacao",
        name: "publicacao",
        meta: {
          allowedPermissions: ["publicacao_list"],
        },
        component: () => import("@/views/Publicacao/PublicacaoHome.vue"),
      },
      {
        path: "/publicacao/novo",
        name: "cadastrar_publicacao",
        meta: {
          allowedPermissions: ["publicacao_create"],
        },
        component: () => import("@/views/Publicacao/PublicacaoCad.vue"),
      },
      {
        path: "/publicacao/edit/:id",
        name: "editar_publicacao",
        meta: {
          allowedPermissions: ["publicacao_edit"],
        },
        component: () => import("@/views/Publicacao/PublicacaoEd.vue"),
      },
    ],
  },
  {
    path: "/familiaindigena",
    redirect: "/familiaindigena",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/familiaindigena",
        name: "familiaindigena",
        meta: {
          allowedPermissions: ["familia_indigena_list"],
        },
        component: () =>
          import("@/views/FamiliaIndigena/FamiliaIndigenaHome.vue"),
      },
      {
        path: "/familiaindigena/novo",
        name: "familia_indigena_cadastrar",
        meta: {
          allowedPermissions: ["familia_indigena_create"],
        },
        component: () =>
          import("@/views/FamiliaIndigena/FamiliaIndigenaCad.vue"),
      },
      {
        path: "/familiaindigena/edit/:id",
        name: "familia_indigena_editar",
        meta: {
          allowedPermissions: ["familia_indigena_edit"],
        },
        component: () =>
          import("@/views/FamiliaIndigena/FamiliaIndigenaEd.vue"),
      },
    ],
  },
  {
    path: "/idiomaindigena",
    redirect: "/idiomaindigena",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/idiomaindigena",
        name: "idiomaindigena",
        meta: {
          allowedPermissions: ["idioma_indigena_list"],
        },
        component: () =>
          import("@/views/IdiomaIndigena/IdiomaIndigenaHome.vue"),
      },
      {
        path: "/idiomaindigena/novo",
        name: "idioma_indigena_cadastrar",
        meta: {
          allowedPermissions: ["idioma_indigena_create"],
        },
        component: () => import("@/views/IdiomaIndigena/IdiomaIndigenaCad.vue"),
      },
      {
        path: "/idiomaindigena/edit/:id",
        name: "idioma_indigena_editar",
        meta: {
          allowedPermissions: ["idioma_indigena_edit"],
        },
        component: () => import("@/views/IdiomaIndigena/IdiomaIndigenaEd.vue"),
      },
    ],
  },
  {
    path: "/equipamentos",
    redirect: "/equipamentos",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/equipamentos",
        name: "equipamentos",
        meta: {
          allowedPermissions: ["equipamento_index"],
        },
        component: () => import("@/views/Equipamento/EquipamentoHome.vue"),
      },
      {
        path: "/equipamentos/novo",
        name: "equipamentos-novo",
        meta: {
          allowedPermissions: ["equipamento_create"],
        },
        component: () => import("@/views/Equipamento/EquipamentoCad.vue"),
      },
      {
        path: "/equipamentos/editar/:id",
        name: "equipamentos-editar",
        meta: {
          allowedPermissions: ["equipamento_edit"],
        },
        component: () => import("@/views/Equipamento/EquipamentoEd.vue"),
      },
    ],
  },
  {
    path: "/tipo_deficiencias",
    redirect: "/tipo_deficiencias",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/tipo_deficiencias",
        name: "/tipo_deficiencias",
        meta: {
          allowedPermissions: ["tipodeficiencia_index"],
        },
        component: () => import("@/views/DeficienciaTipo/DeficienciaHome.vue"),
      },
      {
        path: "/cadastrar_tipo_deficiencia",
        name: "cadastrar_tipo_deficiencia",
        meta: {
          allowedPermissions: ["tipodeficiencia_create"],
        },
        component: () => import("@/views/DeficienciaTipo/DeficienciaCad.vue"),
      },
      {
        path: "/editar_tipo_deficiencia/:id",
        name: "editar_tipo_deficiencia",
        meta: {
          allowedPermissions: ["tipodeficiencia_edit"],
        },
        component: () => import("@/views/DeficienciaTipo/DeficienciaEd.vue"),
      },
    ],
  },
  {
    path: "/ensino",
    redirect: "/ensino",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/ensino/novo",
        name: "ensinocad",
        meta: {
          allowedPermissions: ["ensino_create"],
        },
        component: () => import("@/views/Ensino/EnsinoCad.vue"),
      },
      {
        path: "/ensino/edit/:id",
        name: "ensinoedit",
        meta: {
          allowedPermissions: ["ensino_edit"],
        },
        component: () => import("@/views/Ensino/EnsinoEdit.vue"),
      },
      {
        path: "/ensino",
        name: "ensino",
        meta: {
          allowedPermissions: ["ensino_list"],
        },
        component: () => import("@/views/Ensino/EnsinoHome.vue"),
      },
    ],
  },
  {
    path: "/ensinos_rede",
    redirect: "/ensinos_rede",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/ensinos_rede/novo",
        name: "ensinosredenovo",
        meta: {
          allowedPermissions: ["ensino_rede_create"],
        },
        component: () => import("@/views/EnsinosRede/EnsinosRedeCadastro.vue"),
      },
      {
        path: "/ensinos_rede/:id",
        name: "ensinosredeedit",
        meta: {
          allowedPermissions: ["ensino_rede_show"],
        },
        component: () => import("@/views/EnsinosRede/EnsinosRedeEdit.vue"),
      },
      {
        path: "/ensinos_rede",
        name: "ensinosrede",
        meta: {
          allowedPermissions: ["ensino_rede_list", "ensino_rede_delete"],
        },
        component: () => import("@/views/EnsinosRede/EnsinosRedeHome.vue"),
      },
    ],
  },
  {
    path: "/fase_ensino",
    redirect: "/fase_ensino",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/fase_ensino/novo",
        name: "fase_ensinocad",
        meta: {
          allowedPermissions: ["fase_create"],
        },
        component: () => import("@/views/Fase/FaseEnsCad.vue"),
      },
      {
        path: "/fase_ensino/edit/:id",
        name: "fase_ensinoedit",
        meta: {
          allowedPermissions: ["fase_edit"],
        },
        component: () => import("@/views/Fase/FaseEnsEdit.vue"),
      },
      {
        path: "/fase_ensino",
        name: "fase_ensino",
        meta: {
          allowedPermissions: ["fase_list"],
        },
        component: () => import("@/views/Fase/FaseEnsHome.vue"),
      },
    ],
  },
  {
    path: "/capacidade_pedagogica",
    redirect: "/capacidade_pedagogica",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/capacidade_pedagogica/novo",
        name: "capacidade_pedagogicacad",
        meta: {
          allowedPermissions: ["capacidadepedagogica_create"],
        },
        component: () =>
          import("@/views/CapacidadePedagogica/CapPedEnsCad.vue"),
      },
      {
        path: "/capacidade_pedagogica/edit/:id",
        name: "capacidade_pedagogicaedit",
        meta: {
          allowedPermissions: ["capacidadepedagogica_edit"],
        },
        component: () =>
          import("@/views/CapacidadePedagogica/CapPedEnsEdit.vue"),
      },
      {
        path: "/capacidade_pedagogica",
        name: "capacidade_pedagogica",
        meta: {
          allowedPermissions: ["capacidadepedagogica_list"],
        },
        component: () =>
          import("@/views/CapacidadePedagogica/CapPedEnsHome.vue"),
      },
    ],
  },
  {
    path: "/conceito",
    redirect: "/conceito",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/conceito/novo",
        name: "conceitocad",
        meta: {
          allowedPermissions: ["conceito_create"],
        },
        component: () => import("@/views/EnsinoConceito/ConceitoCad.vue"),
      },
      {
        path: "/conceito/edit/:id",
        name: "conceitoedit",
        meta: {
          allowedPermissions: ["conceito_edit"],
        },
        component: () => import("@/views/EnsinoConceito/ConceitoEdit.vue"),
      },
      {
        path: "/conceito",
        name: "conceito",
        meta: {
          allowedPermissions: ["conceito_list"],
        },
        component: () => import("@/views/EnsinoConceito/ConceitoHome.vue"),
      },
    ],
  },
  {
    path: "/origem_fase_ensino",
    redirect: "/origem_fase_ensino",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/origem_fase_ensino/novo",
        name: "fasedeorigemdeumensinodecorrecaodefluxo_novo",
        meta: {
          allowedPermissions: ["faseorigem_create"],
        },
        component: () =>
          import(
            "@/views/FaseDeOrigemDeUmEnsinoDeCorrecaoDeFluxo/FaseDeOrigemDeUmEnsinoDeCorrecaoDeFluxoCad.vue"
          ),
      },
      {
        path: "/origem_fase_ensino/edit/:id",
        name: "fasedeorigemdeumensinodecorrecaodefluxo_atualizar",
        meta: {
          allowedPermissions: ["faseorigem_edit"],
        },
        component: () =>
          import(
            "@/views/FaseDeOrigemDeUmEnsinoDeCorrecaoDeFluxo/FaseDeOrigemDeUmEnsinoDeCorrecaoDeFluxoEdit.vue"
          ),
      },
      {
        path: "/origem_fase_ensino",
        name: "fasedeorigemdeumensinodecorrecaodefluxo",
        meta: {
          allowedPermissions: ["faseorigem_list"],
        },
        component: () =>
          import(
            "@/views/FaseDeOrigemDeUmEnsinoDeCorrecaoDeFluxo/FaseDeOrigemDeUmEnsinoDeCorrecaoDeFluxoHome.vue"
          ),
      },
    ],
  },
  {
    path: "/fase_ensino_concluida",
    redirect: "/fase_ensino_concluida",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/fase_ensino_concluida/novo",
        name: "fase_ensino_concluidacad",
        meta: {
          allowedPermissions: ["faseconcluida_create"],
        },
        component: () => import("@/views/ConclusaoFluxo/ConFluxCad.vue"),
      },
      {
        path: "/fase_ensino_concluida/edit/:id",
        name: "fase_ensino_concluidaedit",
        meta: {
          allowedPermissions: ["faseconcluida_edit"],
        },
        component: () => import("@/views/ConclusaoFluxo/ConFluxEdit.vue"),
      },
      {
        path: "/fase_ensino_concluida",
        name: "fase_ensino_concluida",
        meta: {
          allowedPermissions: ["faseconcluida_list"],
        },
        component: () => import("@/views/ConclusaoFluxo/ConFluxHome.vue"),
      },
    ],
  },
  {
    path: "/aspecto",
    redirect: "/aspecto",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/aspecto/novo",
        name: "aspectocad",
        meta: {
          allowedPermissions: ["aspectosocioafetivo_create"],
        },
        component: () => import("@/views/AspectoSocioafetivo/AspectoCad.vue"),
      },
      {
        path: "/aspecto/edit/:id",
        name: "aspectoedit",
        meta: {
          allowedPermissions: ["aspectosocioafetivo_edit"],
        },
        component: () => import("@/views/AspectoSocioafetivo/AspectoEdit.vue"),
      },
      {
        path: "/aspecto",
        name: "aspecto",
        meta: {
          allowedPermissions: ["aspectosocioafetivo_list"],
        },
        component: () => import("@/views/AspectoSocioafetivo/AspectoHome.vue"),
      },
    ],
  },
  {
    path: "/estrutura_aspecto",
    redirect: "/estrutura_aspecto",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/estrutura_aspecto/novo",
        name: "estrutura_aspectocad",
        meta: {
          allowedPermissions: ["estruturaaspectosocio_create"],
        },
        component: () => import("@/views/AspectoEstrutura/EstruAspectoCad.vue"),
      },
      {
        path: "/estrutura_aspecto/edit/:id",
        name: "estrutura_aspectoedit",
        meta: {
          allowedPermissions: ["estruturaaspectosocio_edit"],
        },
        component: () =>
          import("@/views/AspectoEstrutura/EstruAspectoEdit.vue"),
      },
      {
        path: "/estrutura_aspecto",
        name: "estrutura_aspecto",
        meta: {
          allowedPermissions: ["estruturaaspectosocio_list"],
        },
        component: () =>
          import("@/views/AspectoEstrutura/EstruAspectoHome.vue"),
      },
    ],
  },
  {
    path: "/associar_aspecto",
    redirect: "/associar_aspecto",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/associar_aspecto/novo",
        name: "associar_aspectocad",
        meta: {
          allowedPermissions: ["estruturaaspectosocio_create"],
        },
        component: () => import("@/views/AspectoAssociacao/AssAspectoCad.vue"),
      },
      {
        path: "/associar_aspecto/edit/:id",
        name: "associar_aspectoedit",
        meta: {
          allowedPermissions: ["estruturaaspectosocio_edit"],
        },
        component: () => import("@/views/AspectoAssociacao/AssAspectoEdit.vue"),
      },
      {
        path: "/associar_aspecto",
        name: "associar_aspecto",
        meta: {
          allowedPermissions: ["estruturaaspectosocio_list"],
        },
        component: () => import("@/views/AspectoAssociacao/AssAspectoHome.vue"),
      },
    ],
  },
  {
    path: "/cursos",
    redirect: "/cursos",
    component: () => import("@/layout/Layout.vue"),
    meta: {
      breadCrumb: "Cadastros Gerais - Cadastros Básicos",
    },
    children: [
      {
        path: "/cursos/novo",
        name: "cursos_novo",
        meta: {
          allowedPermissions: ["curso_create"],
        },
        component: () => import("@/views/Cursos/CursosCad.vue"),
      },
      {
        path: "/cursos/edit/:id",
        name: "cursos_atualizar",
        meta: {
          allowedPermissions: ["curso_edit"],
        },
        component: () => import("@/views/Cursos/CursosEdit.vue"),
      },
      {
        path: "/cursos",
        name: "cursos",
        meta: {
          allowedPermissions: ["curso_index"],
        },
        component: () => import("@/views/Cursos/CursosHome.vue"),
      },
    ],
  },
  {
    path: "/disciplina",
    redirect: "/disciplina",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/disciplina/novo",
        name: "disciplina_novo",
        meta: {
          allowedPermissions: ["disciplina_create"],
        },
        component: () => import("@/views/Disciplina/DisciplinaCad.vue"),
      },
      {
        path: "/disciplina/edit/:id",
        name: "disciplina_atualizar",
        meta: {
          allowedPermissions: ["disciplina_edit"],
        },
        component: () => import("@/views/Disciplina/DisciplinaEdit.vue"),
      },
      {
        path: "/disciplina",
        name: "disciplina",
        meta: {
          allowedPermissions: ["disciplina_list"],
        },
        component: () => import("@/views/Disciplina/DisciplinaHome.vue"),
      },
    ],
  },
  {
    path: "/opcoes-componente",
    redirect: "/opcoes-componente",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/opcoes-componente/novo",
        name: "opcoes-componente-novo",
        meta: {
          allowedPermissions: ["disciplina_list"],
        },
        component: () =>
          import("@/views/OpcoesComponente/OpcoesComponenteCad.vue"),
      },
      {
        path: "/opcoes-componente/editar/:id",
        name: "opcoes-componente-editar",
        meta: {
          allowedPermissions: ["disciplina_list"],
        },
        component: () =>
          import("@/views/OpcoesComponente/OpcoesComponenteEdit.vue"),
      },
      {
        path: "/opcoes-componente",
        name: "opcoes-componente",
        meta: {
          allowedPermissions: ["disciplina_list"],
        },
        component: () =>
          import("@/views/OpcoesComponente/OpcoesComponenteHome.vue"),
      },
    ],
  },
  {
    path: "/area_conhecimento",
    redirect: "/area_conhecimento",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/area_conhecimento/novo",
        name: "areadeconhecimento_novo",
        meta: {
          allowedPermissions: ["areaconhecimento_create"],
        },
        component: () =>
          import("@/views/AreaDeConhecimento/AreaDeConhecimentoCad.vue"),
      },
      {
        path: "/area_conhecimento/edit/:id",
        name: "areadeconhecimento_atualizar",
        meta: {
          allowedPermissions: ["areaconhecimento_edit"],
        },
        component: () =>
          import("@/views/AreaDeConhecimento/AreaDeConhecimentoEdit.vue"),
      },
      {
        path: "/area_conhecimento",
        name: "areaconhecimento",
        meta: {
          allowedPermissions: ["areaconhecimento_list"],
        },
        component: () =>
          import("@/views/AreaDeConhecimento/AreaDeConhecimentoHome.vue"),
      },
    ],
  },
  {
    path: "/estrutura_curricular",
    redirect: "/estrutura_curricular",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/estrutura_curricular/novo",
        name: "estruturacurricular_novo",
        meta: {
          allowedPermissions: ["estruturacurricular_create"],
        },
        component: () =>
          import("@/views/EstruturaCurricular/EstruturaCurricularCad.vue"),
      },
      {
        path: "/estrutura_curricular/edit/:id",
        name: "estruturacurricular_atualizar",
        meta: {
          allowedPermissions: ["estruturacurricular_edit"],
        },
        component: () =>
          import("@/views/EstruturaCurricular/EstruturaCurricularEdit.vue"),
      },
      {
        path: "/estrutura_curricular",
        name: "estrutura_curricular",
        meta: {
          allowedPermissions: ["estruturacurricular_list"],
        },
        component: () =>
          import("@/views/EstruturaCurricular/EstruturaCurricularHome.vue"),
      },
    ],
  },
  {
    path: "/associar_disciplina_estrutura",
    redirect: "/associar_disciplina_estrutura",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/associar_disciplina_estrutura/novo",
        name: "associardisciplinaparaestruturacurricular_novo",
        meta: {
          allowedPermissions: ["componentes_estrutura_create"],
        },
        component: () =>
          import(
            "@/views/AssociarDisciplinaParaEstruturaCurricular/AssociarDisciplinaParaEstruturaCurricularCad.vue"
          ),
      },
      {
        path: "/associar_disciplina_estrutura/edit/:id",
        name: "associardisciplinaparaestruturacurricular_atualizar",
        meta: {
          allowedPermissions: ["componentes_estrutura_edit"],
        },
        component: () =>
          import(
            "@/views/AssociarDisciplinaParaEstruturaCurricular/AssociarDisciplinaParaEstruturaCurricularEdit.vue"
          ),
      },
      {
        path: "/associar_disciplina_estrutura",
        name: "associardisciplinaparaestruturacurricular",
        meta: {
          allowedPermissions: ["componentes_estrutura_list"],
        },
        component: () =>
          import(
            "@/views/AssociarDisciplinaParaEstruturaCurricular/AssociarDisciplinaParaEstruturaCurricularHome.vue"
          ),
      },
    ],
  },
  {
    path: "/base_nacional_comum",
    redirect: "/base_nacional_comum",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/base_nacional_comum/novo",
        name: "basenacionalcomum_novo",
        meta: {
          allowedPermissions: ["basenacional_create"],
        },
        component: () =>
          import("@/views/BaseNacionalComum/BaseNacionalComumCad.vue"),
      },
      {
        path: "/base_nacional_comum/edit/:id",
        name: "basenacionalcomum_atualizar",
        meta: {
          allowedPermissions: ["basenacional_edit"],
        },
        component: () =>
          import("@/views/BaseNacionalComum/BaseNacionalComumEdit.vue"),
      },
      {
        path: "/base_nacional_comum",
        name: "basenacionalcomum",
        meta: {
          allowedPermissions: ["basenacional_list"],
        },
        component: () =>
          import("@/views/BaseNacionalComum/BaseNacionalComumHome.vue"),
      },
    ],
  },
  {
    path: "/associar_disciplina_base",
    redirect: "/associar_disciplina_base",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/associar_disciplina_base/novo",
        name: "associardisciplinadabasenacionalcomum_novo",
        meta: {
          allowedPermissions: ["disciplinabase_create"],
        },
        component: () =>
          import(
            "@/views/AssociarDisciplinaDaBaseNacionalComum/AssociarDisciplinaDaBaseNacionalComumCad.vue"
          ),
      },
      {
        path: "/associar_disciplina_base/edit/:id",
        name: "associardisciplinadabasenacionalcomum_atualizar",
        meta: {
          allowedPermissions: ["disciplinabase_edit"],
        },
        component: () =>
          import(
            "@/views/AssociarDisciplinaDaBaseNacionalComum/AssociarDisciplinaDaBaseNacionalComumEdit.vue"
          ),
      },
      {
        path: "/associar_disciplina_base",
        name: "associar_disciplina_base",
        meta: {
          allowedPermissions: ["disciplinabase_list"],
        },
        component: () =>
          import(
            "@/views/AssociarDisciplinaDaBaseNacionalComum/AssociarDisciplinaDaBaseNacionalComumHome.vue"
          ),
      },
    ],
  },
  {
    path: "/regimento",
    redirect: "/regimento",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/regimento/novo",
        name: "regimentoescolar_novo",
        meta: {
          allowedPermissions: ["regimeescolar_create"],
        },
        component: () =>
          import("@/views/RegimentoEscolar/RegimentoEscolarCad.vue"),
      },
      {
        path: "/regimento/edit/:id",
        name: "regimentoescolar_atualizar",
        meta: {
          allowedPermissions: ["regimeescolar_edit"],
        },
        component: () =>
          import("@/views/RegimentoEscolar/RegimentoEscolarEdit.vue"),
      },
      {
        path: "/regimento/:id/conceitos",
        name: "regimentoescolar_conceitos",
        meta: {
          allowedPermissions: ["regimeescolar_edit"],
        },
        component: () =>
          import(
            "@/views/RegimentoEscolar/ListagemConceitoRegimeEscolarHome.vue"
          ),
      },
      {
        path: "/regimento/:id/novo-conceito",
        name: "regimentoescolar_novoconceito",
        meta: {
          allowedPermissions: ["regimeescolar_edit"],
        },
        component: () =>
          import("@/views/RegimentoEscolar/CadastroConceitoRegimeEscolar.vue"),
      },
      {
        path: "/regimento",
        name: "regimentoescolar",
        meta: {
          allowedPermissions: ["regimeescolar_list"],
        },
        component: () =>
          import("@/views/RegimentoEscolar/RegimentoEscolarHome.vue"),
      },
    ],
  },
  {
    path: "/periodos_letivos",
    redirect: "/periodos_letivos",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/periodos_letivos/novo",
        name: "periodos_letivoscad",
        meta: {
          allowedPermissions: ["periodo_create"],
        },
        component: () => import("@/views/PeriodoLetivo/PeriodoCad.vue"),
      },
      {
        path: "/periodos_letivos/edit/:id",
        name: "periodos_letivosedit",
        meta: {
          allowedPermissions: ["periodo_edit"],
        },
        component: () => import("@/views/PeriodoLetivo/PeriodoEdit.vue"),
      },
      {
        path: "/periodos_letivos",
        name: "periodos_letivos",
        meta: {
          allowedPermissions: ["periodo_list"],
        },
        component: () => import("@/views/PeriodoLetivo/PeriodosHome.vue"),
      },
    ],
  },
  {
    path: "/atividade_escolar",
    redirect: "/atividade_escolar",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/atividade_escolar/novo",
        name: "atividade_escolarcad",
        meta: {
          allowedPermissions: ["atividadeescolcar_create"],
        },
        component: () => import("@/views/AtividadeEscolar/AtividadeCad.vue"),
      },
      {
        path: "/atividade_escolar/edit/:id",
        name: "atividade_escolaredit",
        meta: {
          allowedPermissions: ["atividadeescolcar_edit"],
        },
        component: () => import("@/views/AtividadeEscolar/AtividadeEd.vue"),
      },
      {
        path: "/atividade_escolar",
        name: "atividade_escolar",
        meta: {
          allowedPermissions: ["atividadeescolcar_list"],
        },
        component: () => import("@/views/AtividadeEscolar/AtividadeHome.vue"),
      },
    ],
  },
  {
    path: "/calendario_escolar",
    redirect: "/calendario_escolar",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/calendario_escolar/novo",
        name: "calendario_escolarcad",
        meta: {
          allowedPermissions: ["calendarioescolar_create"],
        },
        component: () =>
          import("@/views/CalendarioEscolar/CalendarioEscolarCad.vue"),
      },
      {
        path: "/calendario_escolar/edit/:id",
        name: "calendario_escolaredit",
        meta: {
          allowedPermissions: ["calendarioescolar_edit"],
        },
        component: () =>
          import("@/views/CalendarioEscolar/CalendarioEscolarEd.vue"),
      },
      {
        path: "/calendario_escolar",
        name: "calendario_escolar",
        meta: {
          allowedPermissions: ["calendarioescolar_list"],
        },
        component: () =>
          import("@/views/CalendarioEscolar/CalendariosEscolarHome.vue"),
      },
    ],
  },
  {
    path: "/associar_atividade_escolar",
    redirect: "/calendario_escolar",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/associar_atividade_escolar/novo",
        name: "associar_calendario_escolarcad",
        meta: {
          allowedPermissions: ["atividadecalendario_create"],
        },
        component: () =>
          import(
            "@/views/AssociarAtividadeEscolar/AssCalendarioEscolarCad.vue"
          ),
      },
      {
        path: "/associar_atividade_escolar/edit/:id",
        name: "associar_calendario_escolaredit",
        meta: {
          allowedPermissions: ["atividadecalendario_edit"],
        },
        component: () =>
          import("@/views/AssociarAtividadeEscolar/AssCalendarioEscolarEd.vue"),
      },
      {
        path: "/associar_atividade_escolar",
        name: "associar_atividade_escolar",
        meta: {
          allowedPermissions: ["atividadecalendario_list"],
        },
        component: () =>
          import(
            "@/views/AssociarAtividadeEscolar/AssCalendariosEscolarHome.vue"
          ),
      },
    ],
  },
  {
    path: "/calendario_civil",
    redirect: "/calendario_civil",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/calendario_civil/dias",
        name: "dias_calendario_civil",
        meta: {
          allowedPermissions: ["calendariocivil_abrircalendario"],
        },
        component: () =>
          import("@/views/CalendarioCivil/DiasCalendarioCivil.vue"),
      },
      {
        path: "/calendario_civil",
        name: "calendario_civil",
        meta: {
          allowedPermissions: ["calendariocivil_abrircalendario"],
        },
        component: () =>
          import("@/views/CalendarioCivil/CalendarioCivilCad.vue"),
      },
    ],
  },
  {
    path: "/etnias",
    redirect: "/etnias",
    component: () => import("@/layout/Layout.vue"),
    meta: {
      breadCrumb: "Cadastros Gerais - Cadastros Básicos",
    },
    children: [
      {
        path: "/etnias",
        name: "etnias",
        meta: {
          allowedPermissions: ["etnia_index"],
        },
        component: () => import("@/views/Etnia/EtniaHome.vue"),
      },
      {
        path: "/etnias/cadastro",
        name: "cadastrar_etnia",
        meta: {
          allowedPermissions: ["etnia_create"],
        },
        component: () => import("@/views/Etnia/EtniaCad.vue"),
      },
      {
        path: "/etnias/edicao/:id",
        name: "editar_etnia",
        meta: {
          allowedPermissions: ["etnia_edit"],
        },
        component: () => import("@/views/Etnia/EtniaEdit.vue"),
      },
    ],
  },
  {
    path: "/deficiencias",
    redirect: "/deficiencias",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/deficiencias",
        name: "deficiencias",
        meta: {
          allowedPermissions: ["deficiencia_index"],
        },
        component: () => import("@/views/Deficiencia/DeficienciaHome.vue"),
      },
      {
        path: "/deficiencias/novo",
        name: "deficiencias-novo",
        meta: {
          allowedPermissions: ["deficiencia_create"],
        },
        component: () => import("@/views/Deficiencia/DeficienciaCad.vue"),
      },
      {
        path: "/deficiencias/editar/:id",
        name: "deficiencias-editar",
        meta: {
          allowedPermissions: ["deficiencia_edit"],
        },
        component: () => import("@/views/Deficiencia/DeficienciaEd.vue"),
      },
    ],
  },
  ...manutencao_historico,
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    meta: {
      requireAuth: false,
    },
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function validarAutorizacao(to, permissions) {
  if (to.meta.requireAuth === false) {
    return true;
  }

  if (!KeycloakService.getInstance().authenticated) {
    KeycloakService.getInstance().login();
  }

  if (!to.meta.allowedPermissions) {
    return false;
  }

  if (!Array.isArray(to.meta.allowedPermissions)) {
    return false;
  }

  if (to.meta.allowedPermissions.some((item) => permissions.includes(item))) {
    return true;
  }

  return false;
}

router.beforeEach(async (to, from, next) => {
  //reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  const usuarioStore = useUsuarioStore();
  if (!usuarioStore.dadosCarregados) {
    try {
      await usuarioStore.carregarDadosUsuario();
    } catch (error) {
      console.error("Erro ao carregar dados do usuário:", error);
    }
  }

  const storedMenuData: string = localStorage.getItem("menuData") || "";
  const permissions = Object.values(JSON.parse(storedMenuData)).flat();

  if (validarAutorizacao(to, permissions)) {
    next();
  } else {
    MensagemService.erro({
      texto: "Você não tem permissão para acessar este recurso!",
      confirmButtonText: "OK",
    });
  }

  //Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
